import { useStore } from 'effector-react'
import * as React from 'react'

import { $userProfile, userProfileMounted } from './model'

export const useUserProfile = () => {
  const userProfile = useStore($userProfile)

  React.useEffect(() => {
    userProfileMounted()
  }, [])

  return userProfile
}
